<template>
    <div class="client">
        <div class="row">
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="https://new.siemens.com/cn/zh.html" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p1.jpg" />
                    <figcaption>SIEMENS</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="https://www.schneider-electric.cn/zh/" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p2.jpg" />
                    <figcaption>SCHNERDER</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="https://www.johnsoncontrols.com/" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p3.jpg" />
                    <figcaption>JOHNSON</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="https://www.rockwellautomation.com.cn/" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p4.jpg" />
                    <figcaption>ROCKWELL</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="https://www.honeywell.com.cn/" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p5.jpg" />
                    <figcaption>Honeywell</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="http://www.bray.com.cn/" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p6.jpg" />
                    <figcaption>Bray</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="http://www.abb.com.cn" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p7.jpg" />
                    <figcaption>ABB</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="http://kimo-instruments.com" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p8.jpg" />
                    <figcaption>kimo</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="https://www.belimo.com.cn/zh_CN/" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p9.jpg" />
                    <figcaption>belimo</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="https://www.vaisala.com/en" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p10.jpg" />
                    <figcaption>VAISALA</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="https://www.emerson.com/global" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p11.jpg" />
                    <figcaption>EMERSON</figcaption></a
                >
            </figure>
            <figure class="col-xs-6 col-sm-3 col-md-2 col-lg-20">
                <a href="https://www.epluse.com/" target="_blank"
                    ><img src="../../../../assets/img/mainPage/p12.jpg" />
                    <figcaption>ELEKTRONIK</figcaption></a
                >
            </figure>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        jumpPage(url) {
            this.$router.push(url)
        },
    },
}
</script>
<style scoped>
.client figure {
    margin-bottom: 31px;
}

.client figure > a {
    position: relative;
    display: block;
}

.client figure > a img {
    border: 1px solid #e5e5e5;
}

.client figure > a figcaption {
    color: #fff;
    background-color: transparent;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    line-height: 64px;
    display: none;
}

.client figure > a:hover figcaption {
    display: block;
    background-color: rgba(0, 0, 0, 0.75);
    text-align: center;
}
.row figure img,
.client .row figure img {
    width: 100%;
}
@media (min-width: 992px) and (max-width: 1199px) {
    .client figure > a figcaption {
        line-height: 82px;
    }
}

@media (max-width: 991px) {
    .client figure > a figcaption,
    .client figure > a:hover figcaption {
        display: none;
    }
}

@media (max-width: 767px) {
    .client figure {
        margin-bottom: 20px;
    }

    .case-box div:nth-child(odd),
    .client figure:nth-child(odd) {
        padding-right: 10px;
    }

    .case-box div:nth-child(even),
    .client figure:nth-child(even) {
        padding-left: 10px;
    }

    .client-bg {
        background-size: auto 110%;
    }
}
@media (max-width: 767px) {
    a.btn-center {
        margin: 15px 10px 0 10px;
        padding: 4px 20px 2px 20px;
    }
}
</style>
